import { useContext } from 'react'
import { AccountContext } from '../contexts'

export const useAccountDetails = () => useContext(AccountContext)
